import { render, staticRenderFns } from "./RegistFoodProduct.vue?vue&type=template&id=3e54adf5&scoped=true&"
import script from "./RegistFoodProduct.vue?vue&type=script&lang=js&"
export * from "./RegistFoodProduct.vue?vue&type=script&lang=js&"
import style0 from "./RegistFoodProduct.vue?vue&type=style&index=0&id=3e54adf5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e54adf5",
  null
  
)

export default component.exports